import * as React from "react";

function Cards({color="#333",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M10.167 9.25a.92.92 0 01-.917.917H1.917A.92.92 0 011 9.25V1.917A.92.92 0 011.917 1H9.25a.92.92 0 01.917.917V9.25zM22.999 9.25a.92.92 0 01-.917.917h-7.333a.92.92 0 01-.917-.917V1.917A.92.92 0 0114.749 1h7.333a.92.92 0 01.917.917V9.25zM10.167 22.084a.92.92 0 01-.917.917H1.917A.92.92 0 011 22.084v-7.333a.92.92 0 01.917-.917H9.25a.92.92 0 01.917.917v7.333zM22.999 22.084a.92.92 0 01-.917.917h-7.333a.92.92 0 01-.917-.917v-7.333a.92.92 0 01.917-.917h7.333a.92.92 0 01.917.917v7.333z"
        stroke={color}
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Cards;
